import React from "react";

const SvgAlignment = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      width="20"
      height="20"
      className={className}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      fill="currentColor"
    >
      <g clipPath="url(#clip0_128_7007)">
        <path
          d="M19.4328 2H0.6016C0.442046 2 0.289026 2.06338 0.176205 2.1762C0.0633827 2.28903 0 2.44205 0 2.6016C0 2.76115 0.0633827 2.91417 0.176205 3.027C0.289026 3.13982 0.442046 3.2032 0.6016 3.2032H19.4328C19.5924 3.2032 19.7454 3.13982 19.8582 3.027C19.971 2.91417 20.0344 2.76115 20.0344 2.6016C20.0344 2.44205 19.971 2.28903 19.8582 2.1762C19.7454 2.06338 19.5924 2 19.4328 2Z"
          fill="currentColor"
        />
        <path
          d="M13.8376 6.9126H0.6016C0.442046 6.9126 0.289026 6.97598 0.176205 7.0888C0.0633827 7.20162 0 7.35464 0 7.5142C0 7.67375 0.0633827 7.82677 0.176205 7.93959C0.289026 8.05242 0.442046 8.1158 0.6016 8.1158H13.8376C13.9972 8.1158 14.1502 8.05242 14.263 7.93959C14.3758 7.82677 14.4392 7.67375 14.4392 7.5142C14.4392 7.35464 14.3758 7.20162 14.263 7.0888C14.1502 6.97598 13.9972 6.9126 13.8376 6.9126Z"
          fill="currentColor"
        />
        <path
          d="M19.4328 11.8843H0.6016C0.442046 11.8843 0.289026 11.9477 0.176205 12.0605C0.0633827 12.1733 0 12.3263 0 12.4859C0 12.6454 0.0633827 12.7985 0.176205 12.9113C0.289026 13.0241 0.442046 13.0875 0.6016 13.0875H19.4328C19.5924 13.0875 19.7454 13.0241 19.8582 12.9113C19.971 12.7985 20.0344 12.6454 20.0344 12.4859C20.0344 12.3263 19.971 12.1733 19.8582 12.0605C19.7454 11.9477 19.5924 11.8843 19.4328 11.8843Z"
          fill="currentColor"
        />
        <path
          d="M9.0846 16.7969H0.6016C0.442046 16.7969 0.289026 16.8603 0.176205 16.9731C0.0633827 17.0859 0 17.2389 0 17.3985C0 17.558 0.0633827 17.711 0.176205 17.8239C0.289026 17.9367 0.442046 18.0001 0.6016 18.0001H9.0846C9.24415 18.0001 9.39717 17.9367 9.50999 17.8239C9.62282 17.711 9.6862 17.558 9.6862 17.3985C9.6862 17.2389 9.62282 17.0859 9.50999 16.9731C9.39717 16.8603 9.24415 16.7969 9.0846 16.7969Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_128_7007">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAlignment;
